import script from "./chooseCourseName.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseCourseName.vue?vue&type=script&setup=true&lang=js"

import "./chooseCourseName.vue?vue&type=style&index=0&id=3e8b6d97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e8b6d97"]])

export default __exports__